import { AxiosResponse } from 'axios';

import api from 'services/api';
import { DuplicateEventProps } from './types';
import { Event } from 'features/common/types';

export const DuplicateEvent = ({ eventId }: DuplicateEventProps): Promise<AxiosResponse<Event>> =>
	api.post(`/events/${eventId}/duplicate`);
